import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const titleize = (segment) => segment
  .split('-')
  .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
  .join(' ');

const Breadcrumbs = ({ base = '' }) => {
  const location = useLocation();
  const parts = location.pathname.replace(/^\/+|\/+$/g, '').split('/').filter(Boolean);

  const items = [];
  let path = '';
  for (let i = 0; i < parts.length; i++) {
    path += '/' + parts[i];
    items.push({
      label: titleize(parts[i]),
      to: path,
      active: i === parts.length - 1,
    });
  }

  if (!items.length) return null;

  return (
    <nav className="text-sm text-gray-500" aria-label="Breadcrumb">
      <ol className="flex items-center gap-2 flex-wrap">
        <li>
          <Link to="/" className="hover:text-gray-900">Home</Link>
        </li>
        {items.map((item, idx) => (
          <React.Fragment key={item.to}>
            <li aria-hidden className="text-gray-400">/</li>
            <li>
              {item.active ? (
                <span className="text-gray-900 font-medium">{item.label}</span>
              ) : (
                <Link to={item.to} className="hover:text-gray-900">{item.label}</Link>
              )}
            </li>
          </React.Fragment>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;


